import { Flow } from "../types";
import { SCREENS } from "../screens";

export const MS_SELF_SERVICE: Flow = {
  [SCREENS.WELCOME]: {
    next: () => SCREENS.CUSTOMER,
    back: () => null,
  },
  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.VEHICLE,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.VEHICLE]: {
    next: () => SCREENS.PAYMENTS,
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.VEHICLE,
  },
  [SCREENS.RECAPITULATION]: {
    next: () => SCREENS.VIEW,
    back: () => SCREENS.PAYMENTS,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
